package fr.frux.core.ads

/**
 * Configuration de build de la publicité. Android la reçoit de `androidApp` (BuildConfig, #527 T3),
 * les autres cibles rendent [DISABLED]. Les identifiants d'unités arrivent avec leurs emplacements :
 * [interstitialUnitId] avec #528 et [bannerUnitId] avec #529, vides tant que l'unité n'est pas
 * configurée (aucun chargement).
 */
data class AdsConfig(
    val enabled: Boolean,
    val interstitialUnitId: String = "",
    /** Bloc de la bannière adaptative de la carte (#529), vide tant qu'il n'est pas configuré. */
    val bannerUnitId: String = "",
    /** Bloc natif image seule de la liste « Autour de toi » (#530), vide tant qu'il n'est pas configuré. */
    val nativeUnitId: String = "",
    /** Bloc de la vidéo récompensée (#531), vide tant qu'il n'est pas configuré (aucune offre). */
    val rewardedUnitId: String = "",
) {
    companion object {
        val DISABLED = AdsConfig(enabled = false)
    }
}
